// extracted by mini-css-extract-plugin
module.exports = {"Row":"Row_Row__2WI3d","Block":"Row_Block__32g0_","Lighter":"Row_Lighter__2umet"};